import { Helmet } from 'react-helmet';

import { RealStatePropertyExpenseList } from 'components/templates';

const RealStatePropertyExpenseListPage = () => (
    <>
        <Helmet>
            <title>Lançamentos Imóveis - Painel Imobiliário - Imobiler</title>
        </Helmet>

        <RealStatePropertyExpenseList />
    </>
);

export default RealStatePropertyExpenseListPage;
